document.addEventListener("turbolinks:load", function() {
  $('input[data-mask]').each(function() {
    $(this).mask(this.dataset['mask'])
  });
});
